<h2 mat-dialog-title>Comentario<br>
  <button mat-dialog-close mat-mini-fab class="close" matTooltip="Cancelar">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<!-- Content -->
<mat-dialog-content >
  <mat-form-field appearance="outline" style="margin-top: 20px;">
    <textarea matInput placeholder="Comentario" matTextareaAutosize matAutosizeMinRows="1" matAutosizeMaxRows="12"
      [(ngModel)]="comentario" class="comment-box"></textarea>
  </mat-form-field>
</mat-dialog-content>
<!-- Actions -->
<mat-dialog-actions>
  <button mat-raised-button (click)="dialogRef.close(comentario)">Aceptar</button>

  <button mat-button mat-dialog-close cdkFocusInitial>Cancelar</button>
</mat-dialog-actions>